module.exports = __webpack_public_path__ + "img/drum-steelpan.1237070a.svg";